module.exports = __webpack_public_path__ + "img/access_not_permited.96f3a600.gif";